const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  GET_ORION_INFO_DATA_BEGINS: "GET_ORION_INFO_DATA_BEGINS",
  GET_ORION_INFO_DATA_SUCCESS: "GET_ORION_INFO_DATA_SUCCESS",
  GET_ORION_PRODUCT_CHRACTERISTICS_BEGINS:
    "GET_ORION_PRODUCT_CHRACTERISTICS_BEGINS",
  GET_ORION_PRODUCT_CHRACTERISTICS_SUCCESS:
    "GET_ORION_PRODUCT_CHRACTERISTICS_SUCCESS",
};

export const initialState = {
  orionInfo: null,
  orionInfoFetching: false,
  orionProduct: [],
  orionProductFetching: false,
  orionProductError: false,
};

export const actions = {
  getOrionInfoData: (alias) => ({
    type: types.GET_ORION_INFO_DATA_BEGINS,
    alias,
  }),
  successOrionInfoData: (orionInfoPayload) => ({
    type: types.GET_ORION_INFO_DATA_SUCCESS,
    payload: { orionInfoPayload },
  }),
  getOrionProductData: ({alias, path, conditionList, ignoreProductsWithoutRules,productOffering}) => ({
    type: types.GET_ORION_PRODUCT_CHRACTERISTICS_BEGINS,
    alias,
    path,
    conditionList,
    ignoreProductsWithoutRules,
    productOffering
  }),
  successOrionProductData: (orionProducstCharacteristicsPayload) => ({
    type: types.GET_ORION_PRODUCT_CHRACTERISTICS_SUCCESS,
    payload: { orionProducstCharacteristicsPayload },
  }),
};

function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case HYDRATE: {
      const { orion } = payload;
      return {
        ...state,
        ...orion,
      };
    }
    case types.GET_ORION_INFO_DATA_BEGINS:
      return {
        ...state,
        orionInfoFetching: true,
      };
    case types.GET_ORION_INFO_DATA_SUCCESS:
      const { orionInfoPayload } = payload;
      const { orionInfoRequest, alias, orionInfoStatus } = orionInfoPayload
      let newModule = {
        ...state.orionInfo
      };
      if (!newModule) {
        newModule = {}
      }
      newModule[alias] = orionInfoRequest;
      return {
        ...state,
        orionInfo: newModule,
        orionInfoFetching: false,
      };
    case types.GET_ORION_PRODUCT_CHRACTERISTICS_SUCCESS:
      const { orionProducstCharacteristicsPayload } = payload
      const { orionProducstCharacteristicsRequest, orionProducstCharacteristicsStatus } = orionProducstCharacteristicsPayload;
      return {
        ...state,
        orionProduct: (orionProducstCharacteristicsRequest !== null && Array.isArray(orionProducstCharacteristicsRequest) && orionProducstCharacteristicsRequest.length > 0)
          ? [ ...state.orionProduct, ...orionProducstCharacteristicsRequest ]
          : state.orionProduct,
        orionProductError: orionProducstCharacteristicsStatus,
        orionProductFetching: false,
      };
    case types.GET_ORION_PRODUCT_CHRACTERISTICS_BEGINS:
      return {
        ...state,
        orionProductError: false,
        orionProductFetching: true,
      };
    default:
      return state;
  }
}

export default reducer;
